'use strict';

const APIError = require('./APIError');

/**
 * Thrown when Homey is unreachable.
 * @class
 * @hideconstructor
 * @extends APIError
 */
class APIErrorHomeyOffline extends APIError {

  constructor(err) {
    if (err instanceof Error) {
      super(`Homey Offline (${err.message || err.toString()})`, 500);
    } else {
      super('Homey Offline', 500);
    }
  }

}

module.exports = APIErrorHomeyOffline;
